import React from 'react';
import Link from 'next/link';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';

const hyperlinkStyles = ({ variant, theme }) => {
  if (variant === 'default') {
    return { textDecoration: 'none' };
  }
  if (variant === 'inverted') {
    return {
      wordWrap: 'anywhere',
      color: theme.palette.grey[50],
      textDecoration: 'underline',
      '&:hover': {
        color: theme.palette.grey[400],
      },
      '&:visited:not(:hover)': {
        color: theme.palette.grey[300],
      },
    };
  }
  return {
    wordWrap: 'anywhere',
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
    '&:visited': {
      color: theme.palette.primary.light,
    },
  };
};

const StyledAnchor = styled('a', {
  shouldForwardProp: (p) => !['variant'].includes(p),
})(hyperlinkStyles);

const StyledText = styled(Typography, {
  shouldForwardProp: (p) => !['variant'].includes(p),
})(hyperlinkStyles);

function SmartLink(props) {
  const { to = '', children, variant = 'default' } = props;
  const expr = /^https?:\/\/(www\.)?makemymove\.com/i;
  const isInternalLink = Boolean(to.match(expr));

  return isInternalLink ? (
    <Link href={to.replace(expr, '')}>
      <StyledText variant={variant} component='span'>{children}</StyledText>
    </Link>
  ) : (
    <StyledAnchor href={to} variant={variant} target='_blank' rel='noreferrer'>
      {children}
    </StyledAnchor>
  );
}

export default SmartLink;
